export default {
  googleClientId: '429899463151-2pq00eu19pahf7f1nasr86e72gam2lir.apps.googleusercontent.com',
};
